import { useState, useEffect } from 'react';
import { useStore } from 'zustand';
import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { SearchResults } from './search-results.component';

import { AllSearchResults, SearchType } from '@/app/(main)/_components/search-modal/search-modal.types';
import { FiltersTabs } from '@/components/ui/filters-tab.component';
import { setSelectedFilter, useSearchState } from '@/store/search/search.store';
import { SelectedProcedures } from '@/app/(main)/_components/search-modal/search-modal.types';
import { OverridedUserLocation } from '@/utils/formatters/city/format-place-from-slug.const';

interface SearchFiltersProps {
  results: AllSearchResults;
  searchTerm: string;
  locationOverride?: OverridedUserLocation;
  selectLaboratoryProcedure?: (procedure: SelectedProcedures) => void;
  setOpen: (open: boolean) => void;
  isScrolled?: boolean;
  headerHeight?: number;
}

const all_tabs = [
  { value: SearchType.ALL, label: 'Todos' },
  { value: SearchType.PROCEDURE, label: 'Atendimentos' },
  { value: SearchType.PROFESSIONAL, label: 'Profissionais' },
  { value: SearchType.PARTNER, label: 'Locais' },
];

export function SearchFilters({
  results,
  searchTerm,
  setOpen,
  selectLaboratoryProcedure,
  locationOverride,
  isScrolled = false,
  headerHeight = 0,
}: SearchFiltersProps) {
  const tabs = all_tabs
    .filter((tab) => {
      return results[tab.value as keyof AllSearchResults].results.length > 0;
    })
    .filter((tab, _, array) => {
      return array.length == 2 ? tab.value !== SearchType.ALL : true;
    });

  const selectedFilter = useStore(useSearchState, (state) => state?.selectedFilter);

  const chooseInitialTab = () => {
    if (selectedFilter && tabs.map((tab) => tab.value).includes(selectedFilter as SearchType)) {
      return selectedFilter;
    }

    return tabs.length === 1 ? tabs[0].value : SearchType.ALL;
  };

  const [activeTab, setActiveTab] = useState(chooseInitialTab());

  useEffect(() => {
    if (tabs.length === 1) {
      setActiveTab(tabs[0].value);
    }
  }, [tabs]);

  const handleTabChange = (value: string) => {
    setActiveTab(value as keyof AllSearchResults);
    setSelectedFilter(value);
  };

  return (
    <div className="w-full" data-testid={DataTestIdEnum.PROCEDURES_MODAL_SEARCH_FILTERS}>
      <div
        className={`sticky left-0 right-0 z-10 py-3 transition-colors duration-200 ${isScrolled ? 'bg-gray-50' : 'bg-white'} shadow-floating overflow-hidden`}
        style={{ top: headerHeight > 0 ? `${headerHeight}px` : 0 }}
      >
        <FiltersTabs tabs={tabs} defaultValue={activeTab} onChange={(value) => handleTabChange(value)} />
      </div>
      <div className="w-full pb-5">
        <SearchResults
          key={activeTab}
          searchTerm={searchTerm}
          searchType={activeTab as SearchType}
          results={results[activeTab as keyof AllSearchResults]}
          setOpen={setOpen}
          selectLaboratoryProcedure={selectLaboratoryProcedure}
          locationOverride={locationOverride}
        />
      </div>
    </div>
  );
}
